export * from './dees-input-typelist.js';
